export default __webpack_public_path__ + "static/preview-f32c47531de5d2decd7ba56a44634e52.png";